import { render, staticRenderFns } from "./departmentList.vue?vue&type=template&id=13f7fd46&"
import script from "./departmentList.vue?vue&type=script&lang=js&"
export * from "./departmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports